module.exports = __webpack_public_path__ + "static/media/fal_fal_tie_lad.80576bc3.png";